import { render, staticRenderFns } from "./personal-center.vue?vue&type=template&id=2bf726ce&scoped=true"
import script from "./personal-center.vue?vue&type=script&lang=js"
export * from "./personal-center.vue?vue&type=script&lang=js"
import style0 from "./personal-center.vue?vue&type=style&index=0&id=2bf726ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf726ce",
  null
  
)

export default component.exports